import { LegalPage, LegalSection } from "@/components/LegalPage";

const Cookies = () => (
  <LegalPage
    testid="cookies-page"
    overline="GDPR"
    title="Politica de Cookies"
    updated="octombrie 2026"
  >
    <LegalSection title="1. Ce sunt cookie-urile">
      <p>
        Cookie-urile sunt mici fișiere text salvate în browserul tău atunci
        când vizitezi un site. Ne ajută să înțelegem cum este folosit site-ul
        și să îmbunătățim experiența vizitatorilor.
      </p>
    </LegalSection>

    <LegalSection title="2. Ce cookie-uri folosim">
      <p>
        <strong className="text-ivory">Consimțământ (necesar):</strong>{" "}
        salvăm local alegerea ta din bannerul de cookie-uri (accept sau refuz),
        ca să nu ți-l mai afișăm la fiecare vizită.
      </p>
      <p className="mt-3">
        <strong className="text-ivory">Analiză (PostHog):</strong> statistici
        anonime de utilizare — pagini vizitate, durata vizitei. Acestea sunt
        activate doar dacă apeși „Accept" în banner. La „Refuz", nu se încarcă
        nimic de analiză.
      </p>
    </LegalSection>

    <LegalSection title="3. Cum îți poți schimba alegerea">
      <p>
        Poți șterge oricând datele site-ului din setările browserului tău —
        bannerul de consimțământ va apărea din nou la următoarea vizită și vei
        putea alege altfel.
      </p>
    </LegalSection>

    <LegalSection title="4. Modificări">
      <p>
        Dacă adăugăm alte instrumente care folosesc cookie-uri, vom actualiza
        această pagină înainte de activarea lor.
      </p>
    </LegalSection>
  </LegalPage>
);

export default Cookies;
